import React from "react";

const viewportContext = React.createContext({});

export default viewportContext;